import React, {Component} from 'react';
import {FormControl, Select, Toolbar, Typography} from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';
import MenuItem from "@material-ui/core/MenuItem";


const styles = theme => ({
    root: {
        paddingRight: theme.spacing(1),
        backgroundColor: '#d8d8d8'
    },
    title: {
        flex: '0 0 auto'
    },
    actions: {
        color: theme.palette.text.secondary
    },
    spacer: {
        flex: '1 1 100%'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    }
});

class EnhancedToolbar extends Component {
    render() {
        const {classes, title, categories} = this.props;
        const items = categories.map((item) => {
            return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
        });

        return (
            <Toolbar className={classes.root}>
                <div className={classes.title}>
                    <Typography color="inherit" variant="h6">
                        {title}
                    </Typography>
                </div>
                <div className={classes.spacer} />
                <div className={classes.actions}>
                    <FormControl className={classes.formControl}>
                        <Select
                            onChange={this.props.handleCategorySelect}
                            inputProps={{
                                name: 'category',
                                id: 'category-select'
                            }}
                            value={this.props.selectedCategory}
                        >
                            {items}
                        </Select>
                    </FormControl>
                </div>
            </Toolbar>
        );
    }
}


export default withStyles(styles)(EnhancedToolbar);